"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EinsteinAPI = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _crossFetch = _interopRequireDefault(require("cross-fetch"));
var _utils = require("./utils");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Copyright (c) 2022, salesforce.com, inc.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * SPDX-License-Identifier: BSD-3-Clause
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */
class EinsteinAPI {
  constructor(commerceAPI) {
    var _commerceAPI$_config;
    this.commerceAPI = commerceAPI;
    this.config = commerceAPI === null || commerceAPI === void 0 ? void 0 : (_commerceAPI$_config = commerceAPI._config) === null || _commerceAPI$_config === void 0 ? void 0 : _commerceAPI$_config.einsteinConfig;
  }

  /**
   * Given a POJO append the correct user and cookie identifier values using the current auth state.
   *
   * @param {object} params
   * @returns {object} The decorated body object.
   */
  _buildBody(params) {
    const instanceType_prd = 'prd';
    const instanceType_sbx = 'sbx';
    const body = _objectSpread({}, params);

    // If we have an encrypted user id (authenticaed users only) use it as the `userId` otherwise
    // we won't send a `userId` param for guest users.
    if (this.commerceAPI.auth.encUserId) {
      body.userId = this.commerceAPI.auth.encUserId;
    }

    // Append the `usid` as the `cookieId` value if present. (It should always be present as long
    // as the user is initilized)
    if (this.commerceAPI.auth.usid) {
      body.cookieId = this.commerceAPI.auth.usid;
    } else {
      console.warn('Missing `cookieId`. For optimal results this value must be defined.');
    }

    // The first part of the siteId is the realm
    if (this.config.siteId) {
      body.realm = this.config.siteId.split('-')[0];
    }
    if (this.config.isProduction) {
      body.instanceType = instanceType_prd;
    } else {
      body.instanceType = instanceType_sbx;
    }
    return body;
  }

  /**
   * Given a product or item source, returns the product data that Einstein requires
   */
  _constructEinsteinProduct(product) {
    if (product.type && (product.type.master || product.type.variant)) {
      // handle variants for PDP / viewProduct
      // Assumes product is a Product object from SCAPI Shopper-Products:
      // https://developer.salesforce.com/docs/commerce/commerce-api/references/shopper-products?meta=type%3AProduct
      return {
        id: product.master.masterId,
        sku: product.id,
        altId: '',
        altIdType: ''
      };
    } else if (product.productType && (product.productType.master || product.productType.variant || product.productType.set || product.productType.bundle || product.productType.variationGroup || product.productType.item)) {
      // handle variants & sets for PLP / viewCategory
      // Assumes product is a ProductSearchHit from SCAPI Shopper-Search:
      // https://developer.salesforce.com/docs/commerce/commerce-api/references/shopper-search?meta=type%3AProductSearchHit
      return {
        id: product.productId,
        sku: product.productId,
        //TODO: Should we switch this to product.representedProduct.id once we allow non-master products in search results?
        altId: '',
        altIdType: ''
      };
    } else {
      // handles non-variants
      if (product.productType) {
        return {
          id: product.productId,
          sku: '',
          altId: '',
          altIdType: ''
        };
      } else {
        return {
          id: product.id,
          sku: '',
          altId: '',
          altIdType: ''
        };
      }
    }
  }

  /**
   * Given a cart item, returns the data that Einstein requires
   *
   * Assumes item is a ProductItemfrom SCAPI Shopper-Baskets:
   * https://developer.salesforce.com/docs/commerce/commerce-api/references/shopper-baskets?meta=type%3AProductItem
   */
  _constructEinsteinItem(item) {
    return {
      id: item.productId,
      sku: '',
      price: item.price,
      quantity: item.quantity
    };
  }
  einsteinFetch(endpoint, method, body) {
    var _this = this;
    return (0, _asyncToGenerator2.default)(function* () {
      var _response;
      const config = _this.config;
      const {
        host,
        einsteinId
      } = config;
      const headers = {
        'Content-Type': 'application/json',
        'x-cq-client-id': einsteinId
      };

      // Include `userId` and `cookieId` parameters.
      if (body) {
        body = _this._buildBody(body);
      }
      let response;
      try {
        response = yield (0, _crossFetch.default)(`${host}/v3${endpoint}`, _objectSpread({
          method: method,
          headers: headers
        }, body && {
          body: JSON.stringify(body)
        }));
      } catch {
        console.warn('Einstein request failed');
      }
      if (!((_response = response) !== null && _response !== void 0 && _response.ok)) {
        return {};
      }
      const responseJson = yield response.json();
      return (0, _utils.keysToCamel)(responseJson);
    })();
  }

  /**
   * Tells the Einstein engine when a user views a product.
   * https://developer.salesforce.com/docs/commerce/einstein-api/references#einstein-recommendations:Summary
   **/
  sendViewProduct(product, args) {
    var _this2 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const endpoint = `/activities/${_this2.config.siteId}/viewProduct`;
      const method = 'POST';
      const body = _objectSpread({
        product: _this2._constructEinsteinProduct(product)
      }, args);
      return _this2.einsteinFetch(endpoint, method, body);
    })();
  }

  /**
   * Tells the Einstein engine when a user views search results.
   **/
  sendViewSearch(searchText, searchResults, args) {
    var _this3 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      var _searchResults$hits;
      const endpoint = `/activities/${_this3.config.siteId}/viewSearch`;
      const method = 'POST';

      // @ts-ignore
      const products = searchResults === null || searchResults === void 0 ? void 0 : (_searchResults$hits = searchResults.hits) === null || _searchResults$hits === void 0 ? void 0 : _searchResults$hits.map(product => _this3._constructEinsteinProduct(product));
      const body = _objectSpread({
        searchText,
        products,
        showProducts: true
      }, args);
      return _this3.einsteinFetch(endpoint, method, body);
    })();
  }

  /**
   * Tells the Einstein engine when a user clicks on a search result.
   **/
  sendClickSearch(searchText, product, args) {
    var _this4 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const endpoint = `/activities/${_this4.config.siteId}/clickSearch`;
      const method = 'POST';
      const body = _objectSpread({
        searchText,
        product: _this4._constructEinsteinProduct(product)
      }, args);
      return _this4.einsteinFetch(endpoint, method, body);
    })();
  }

  /**
   * Tells the Einstein engine when a user views a category.
   **/
  sendViewCategory(category, searchResults, args) {
    var _this5 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      var _searchResults$hits2;
      const endpoint = `/activities/${_this5.config.siteId}/viewCategory`;
      const method = 'POST';

      // @ts-ignore
      const products = searchResults === null || searchResults === void 0 ? void 0 : (_searchResults$hits2 = searchResults.hits) === null || _searchResults$hits2 === void 0 ? void 0 : _searchResults$hits2.map(hit => _this5._constructEinsteinProduct(hit));
      const body = _objectSpread({
        category: {
          id: category.id
        },
        products,
        showProducts: true
      }, args);
      return _this5.einsteinFetch(endpoint, method, body);
    })();
  }

  /**
   * Tells the Einstein engine when a user clicks a product from the category page.
   * Not meant to be used when the user clicks a category from the nav bar.
   **/
  sendClickCategory(category, product, args) {
    var _this6 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const endpoint = `/activities/${_this6.config.siteId}/clickCategory`;
      const method = 'POST';
      const body = _objectSpread({
        category: {
          id: category.id
        },
        product: _this6._constructEinsteinProduct(product)
      }, args);
      return _this6.einsteinFetch(endpoint, method, body);
    })();
  }

  /**
   * Tells the Einstein engine when a user views a set of recommendations
   * https://developer.salesforce.com/docs/commerce/einstein-api/references#einstein-recommendations:Summary
   **/
  sendViewReco(recommenderDetails, products, args) {
    var _this7 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const endpoint = `/activities/${_this7.config.siteId}/viewReco`;
      const method = 'POST';
      const {
        __recoUUID,
        recommenderName
      } = recommenderDetails;
      const body = _objectSpread({
        recommenderName,
        __recoUUID,
        products: products
      }, args);
      return _this7.einsteinFetch(endpoint, method, body);
    })();
  }

  /**
   * Tells the Einstein engine when a user clicks on a recommendation
   * https://developer.salesforce.com/docs/commerce/einstein-api/references#einstein-recommendations:Summary
   **/
  sendClickReco(recommenderDetails, product, args) {
    var _this8 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const endpoint = `/activities/${_this8.config.siteId}/clickReco`;
      const method = 'POST';
      const {
        __recoUUID,
        recommenderName
      } = recommenderDetails;
      const body = _objectSpread({
        recommenderName,
        __recoUUID,
        product: _this8._constructEinsteinProduct(product)
      }, args);
      return _this8.einsteinFetch(endpoint, method, body);
    })();
  }

  /**
   * Tells the Einstein engine when a user views a page.
   * Use this only for pages where another activity does not fit. (ie. on the PDP, use viewProduct rather than this)
   **/
  sendViewPage(path, args) {
    var _this9 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const endpoint = `/activities/${_this9.config.siteId}/viewPage`;
      const method = 'POST';
      const body = _objectSpread({
        currentLocation: path
      }, args);
      return _this9.einsteinFetch(endpoint, method, body);
    })();
  }

  /**
   * Tells the Einstein engine when a user starts the checkout process.
   **/
  sendBeginCheckout(basket, args) {
    var _this10 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const endpoint = `/activities/${_this10.config.siteId}/beginCheckout`;
      const method = 'POST';
      const products = basket.productItems.map(item => _this10._constructEinsteinItem(item));
      const subTotal = basket.productSubTotal;
      const body = _objectSpread({
        products: products,
        amount: subTotal
      }, args);
      return _this10.einsteinFetch(endpoint, method, body);
    })();
  }

  /**
   * Tells the Einstein engine when a user reaches the given step during checkout.
   * https://developer.salesforce.com/docs/commerce/einstein-api/references#einstein-recommendations:Summary
   **/
  sendCheckoutStep(stepName, stepNumber, basket, args) {
    var _this11 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const endpoint = `/activities/${_this11.config.siteId}/checkoutStep`;
      const method = 'POST';
      const body = _objectSpread({
        stepName,
        stepNumber,
        basketId: basket.basketId
      }, args);
      return _this11.einsteinFetch(endpoint, method, body);
    })();
  }

  /**
   * Tells the Einstein engine when a user adds an item to their cart.
   * https://developer.salesforce.com/docs/commerce/einstein-api/references#einstein-recommendations:Summary
   **/
  sendAddToCart(item, args) {
    var _this12 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const endpoint = `/activities/${_this12.config.siteId}/addToCart`;
      const method = 'POST';
      const body = _objectSpread({
        products: [_this12._constructEinsteinItem(item)]
      }, args);
      return _this12.einsteinFetch(endpoint, method, body);
    })();
  }

  /**
   * Get a list of recommenders that can be used in recommendation requests.
   * https://developer.salesforce.com/docs/commerce/einstein-api/references#einstein-recommendations:Summary
   **/
  getRecommenders() {
    var _this13 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const endpoint = `/personalization/recommenders/${_this13.config.siteId}`;
      const method = 'GET';
      const body = null;
      return _this13.einsteinFetch(endpoint, method, body);
    })();
  }

  /**
   * Get a set of recommendations
   * https://developer.salesforce.com/docs/commerce/einstein-api/references#einstein-recommendations:Summary
   **/
  getRecommendations(recommenderName, products, args) {
    var _this14 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const endpoint = `/personalization/recs/${_this14.config.siteId}/${recommenderName}`;
      const method = 'POST';
      const body = _objectSpread({
        products: products === null || products === void 0 ? void 0 : products.map(product => _this14._constructEinsteinProduct(product))
      }, args);

      // Fetch the recommendations
      const reco = yield _this14.einsteinFetch(endpoint, method, body);
      reco.recommenderName = recommenderName;
      return _this14.fetchRecProductDetails(reco);
    })();
  }

  /**
   * Get a set of recommendations for a zone
   * https://developer.salesforce.com/docs/commerce/einstein-api/references#einstein-recommendations:Summary
   **/
  getZoneRecommendations(zoneName, products, args) {
    var _this15 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const endpoint = `/personalization/${_this15.config.siteId}/zones/${zoneName}/recs`;
      const method = 'POST';
      const body = _objectSpread({
        products: products === null || products === void 0 ? void 0 : products.map(product => _this15._constructEinsteinProduct(product))
      }, args);

      // Fetch the recommendations
      const reco = yield _this15.einsteinFetch(endpoint, method, body);
      return _this15.fetchRecProductDetails(reco);
    })();
  }
  fetchRecProductDetails(reco) {
    var _this16 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      var _reco$recs;
      const ids = (_reco$recs = reco.recs) === null || _reco$recs === void 0 ? void 0 : _reco$recs.map(rec => rec.id);
      if ((ids === null || ids === void 0 ? void 0 : ids.length) > 0) {
        // Fetch the product details for the recommendations
        const products = yield _this16.commerceAPI.shopperProducts.getProducts({
          parameters: {
            ids: ids.join(',')
          }
        });

        // Merge the product detail into the recommendations response
        return _objectSpread(_objectSpread({}, reco), {}, {
          recs: reco.recs.map(rec => {
            var _products$data;
            const product = products === null || products === void 0 ? void 0 : (_products$data = products.data) === null || _products$data === void 0 ? void 0 : _products$data.find(product => product.id === rec.id);
            return _objectSpread(_objectSpread(_objectSpread({}, rec), product), {}, {
              productId: rec.id,
              image: {
                disBaseLink: rec.imageUrl,
                alt: rec.productName
              }
            });
          })
        });
      }
      return reco;
    })();
  }
}
exports.EinsteinAPI = EinsteinAPI;